<div class="float-end mb-1 mt-1">
  <cap-title-functionbar>
    @if (grundstueckIds.length >= 2) {
      <button
        (click)="getZip()"
        [disabled]="gbPrintService.zipInProgressMap.get(0)"
        class="btn btn-outline-primary btn-sm me-2"
        type="button">
        @if (gbPrintService.zipInProgressMap.get(0)) {
          <span class="spinner-border spinner-border-sm text-primary me-1"></span>
        }
        {{ "Auszüge" | translate }} {{ "(" + grundstueckIds.length + ")" }}
      </button>
    }
  </cap-title-functionbar>
</div>
<cap-grundstueck-table
  (grundstueckIdsListEventItem)="updateCheckedGrundstueckIdList($event)"
  [listLoader]="listLoader"
  [showZeilenSelect]="false">
</cap-grundstueck-table>
